export function getSquircleThumbnailUrl(url) {
  if (url){
    return `https://img1.daumcdn.net/thumb/C100x100.mplusfriend/?fname=${encodeURIComponent(getValidUrl(url))}`;
  }
  return url;
}

export function getValidUrl(url) {
    let validUrl = url;
    if (validUrl.startsWith('//')) {
        validUrl = 'https:'.concat(validUrl);
    }
    return validUrl;
}


// WEBPACK FOOTER //
// ./src/utils/imageUtils.js